import { useIntl } from '@leagueplatform/locales';
import { Box, Image } from '@leagueplatform/genesis-core';
import { StepScreen } from 'components/step-screen/step-screen.component';
import AccountSetupSuccessIconAmplar from 'assets/success-icon.svg';
import { STEP_STRING_IDS } from 'components/onboarding-account-setup/onboarding-account-setup.constants';
import { EVENT_NAME } from '@leagueplatform/analytics';
import { ANALYTICS_SCREEN_NAMES, ANALYTICS_DETAILS } from 'common/constants';
import { useOnboardingAnalytics } from 'hooks/use-onboarding-analytics/use-onboarding-analytics.hook';

export const AmplarCompleteStep = ({
  onComplete,
}: {
  onComplete: () => void;
}) => {
  const { formatMessage } = useIntl();
  const trackEvent = useOnboardingAnalytics(
    ANALYTICS_SCREEN_NAMES.ACCOUNT_SETUP_COMPLETE,
  );

  return (
    <Box css={{ maxWidth: '468px', width: '100%', margin: '0 auto' }}>
      <StepScreen
        centered
        headerContent={
          <Image
            src={AccountSetupSuccessIconAmplar}
            width="132"
            height="132"
            css={{ marginBlockEnd: '$two' }}
          />
        }
        heading={formatMessage({ id: STEP_STRING_IDS.complete.heading })}
        subHeading={formatMessage({ id: STEP_STRING_IDS.complete.subHeading })}
        primaryButton={{
          label: formatMessage({
            id: STEP_STRING_IDS.complete.primaryButtonLabel,
          }),
          onClick: () => {
            trackEvent(EVENT_NAME.BUTTON_CLICKED, {
              detail: ANALYTICS_DETAILS.NAVIGATE_TO_HOME,
            });
            onComplete();
          },
          fullWidth: true,
        }}
      />
    </Box>
  );
};
